import { useParams } from "react-router-dom";
import { useAlert } from "../../../../context/AlertContext";
import { useDeleteSavedSearch } from "../../../../hooks/useSavedSearch";
import { SavedSearch } from "../../../../types/saved-search/SavedSearch";
import { useState } from "react";
import ConfirmDialog from "../../../../components/common/ConfirmDialog/ConfirmDialog";
import { Delete } from "@mui/icons-material";
import { Button } from "@mui/material";

interface DeleteSavedSearchDialogProps {
  selectedSavedSearch: SavedSearch | null;
  handleSavedSearchChange: (savedSearch: SavedSearch | null) => void;
}

export default function DeleteSavedSearchDialog({
  selectedSavedSearch,
  handleSavedSearchChange,
}: Readonly<DeleteSavedSearchDialogProps>) {
  const [opened, setOpened] = useState(false);
  const { customerId } = useParams();
  const showAlert = useAlert();

  const deleteSavedSearchMutation = useDeleteSavedSearch();

  if (!selectedSavedSearch) {
    return null;
  }

  const handleDeleteSavedSearch = async (savedSearchId: string) => {
    try {
      await deleteSavedSearchMutation.mutateAsync({
        customerId: customerId!,
        savedSearchId,
      });
      showAlert("Saved search deleted successfully.", "success");
      handleSavedSearchChange(null);
      setOpened(false);
    } catch (error) {
      showAlert("There was an issue deleting the saved search.", "error");
      console.error("Unknown error deleting saved search:", error);
    }
  };

  return (
    <>
      <Button
        variant="text"
        size="small"
        sx={{ ml: 2 }}
        color="error"
        onClick={() => setOpened(true)}
      >
        Delete Search Template?
      </Button>
      <ConfirmDialog
        isOpen={opened}
        setIsOpen={setOpened}
        title="Delete Saved Search"
        action="delete this saved search"
        confirmText="Delete"
        confirmLeftAdornment={<Delete fontSize="small" />}
        confirmDisabled={deleteSavedSearchMutation.isPending}
        onConfirm={() =>
          handleDeleteSavedSearch(selectedSavedSearch?.savedSearchId)
        }
      />
    </>
  );
}
